import { render, staticRenderFns } from "./ToateRepartizate.vue?vue&type=template&id=27304981&scoped=true&"
import script from "./ToateRepartizate.ts?vue&type=script&lang=ts&"
export * from "./ToateRepartizate.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27304981",
  null
  
)

export default component.exports
import {QSelect,QInput,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QSelect,QInput,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection}, component.options.components || {})
